module.exports = __webpack_public_path__ + "img/Avatar-65.610d9368.svg";